import { type ThemeColors } from "../lib/theme";
import type { ReactNode } from "react";

interface SectionHeaderProps {
  icon: ReactNode;
  title: string;
  theme: ThemeColors;
  isDark: boolean;
  onClick?: () => void;
}

export function SectionHeader({
  icon,
  title,
  theme,
  isDark,
  onClick,
}: SectionHeaderProps) {
  return (
    <div className="flex items-center gap-3" onClick={onClick}>
      <div
        className={`w-8 h-8 rounded-lg flex items-center justify-center ${isDark ? "bg-zinc-800 border border-zinc-700" : "bg-white border border-gray-200"}`}
      >
        <span className={isDark ? "text-zinc-300" : "text-gray-600"}>
          {icon}
        </span>
      </div>
      <h3
        className={`text-sm font-semibold uppercase tracking-wider ${theme.textSecondary}`}
      >
        {title}
      </h3>
    </div>
  );
}
